import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { TooltipProvider } from "@/components/ui/tooltip";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import AppLayout from "@/components/layout/AppLayout";
import WelcomePage from "@/pages/WelcomePage";
import FeedPage from "@/pages/FeedPage";
import DiscoverPage from "@/pages/DiscoverPage";
import StoriesPage from "@/pages/StoriesPage";
import { CommunitiesListPage, CommunityDetailPage } from "@/pages/CommunitiesPage";
import MapPage from "@/pages/MapPage";
import ExplorePage from "@/pages/ExplorePage";
import PrinciplesPage from "@/pages/PrinciplesPage";
import ProjectDetailPage from "@/pages/ProjectDetailPage";
import NGOProfilePage from "@/pages/NGOProfilePage";
import VolunteerPage from "@/pages/VolunteerPage";
import SignUpPage from "@/pages/SignUpPage";
import SignInPage from "@/pages/SignInPage";
import OnboardingPage from "@/pages/OnboardingPage";
import DashboardPage from "@/pages/DashboardPage";
import DonorProfilePage from "@/pages/DonorProfilePage";

function ProtectedRoute({ children }) {
  const { isAuthenticated } = useAuth();
  if (!isAuthenticated) return <Navigate to="/signin" replace />;
  return children;
}

function HomeRedirect() {
  const { isAuthenticated } = useAuth();
  if (!isAuthenticated) return <Navigate to="/welcome" replace />;
  return <AppLayout><FeedPage /></AppLayout>;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/welcome" element={<WelcomePage />} />
      <Route path="/signin" element={<AppLayout hideSidebar hideTopBar><SignInPage /></AppLayout>} />
      <Route path="/signup" element={<AppLayout hideSidebar hideTopBar><SignUpPage /></AppLayout>} />
      <Route path="/" element={<HomeRedirect />} />
      <Route path="/discover" element={<AppLayout><DiscoverPage /></AppLayout>} />
      <Route path="/stories" element={<AppLayout><StoriesPage /></AppLayout>} />
      <Route path="/communities" element={<AppLayout><CommunitiesListPage /></AppLayout>} />
      <Route path="/communities/:slug" element={<AppLayout><CommunityDetailPage /></AppLayout>} />
      <Route path="/map" element={<AppLayout><MapPage /></AppLayout>} />
      <Route path="/explore" element={<AppLayout><ExplorePage /></AppLayout>} />
      <Route path="/principles" element={<AppLayout><PrinciplesPage /></AppLayout>} />
      <Route path="/project/:slug" element={<AppLayout><ProjectDetailPage /></AppLayout>} />
      <Route path="/ngo/:slug" element={<AppLayout><NGOProfilePage /></AppLayout>} />
      <Route path="/volunteer" element={<AppLayout><VolunteerPage /></AppLayout>} />
      <Route path="/onboarding" element={<ProtectedRoute><AppLayout><OnboardingPage /></AppLayout></ProtectedRoute>} />
      <Route path="/dashboard" element={<ProtectedRoute><AppLayout><DashboardPage /></AppLayout></ProtectedRoute>} />
      <Route path="/profile/:username" element={<ProtectedRoute><AppLayout><DonorProfilePage /></AppLayout></ProtectedRoute>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <TooltipProvider>
        <BrowserRouter>
          <AppRoutes />
          <Toaster position="top-center" richColors />
        </BrowserRouter>
      </TooltipProvider>
    </AuthProvider>
  );
}

export default App;
